import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, resetSection } from 'redux-form';
import moment from 'moment';
import { has, get } from 'lodash';

import { ReportGeneration } from 'Common/ObjectHelper';
import { OhioDailyWorksheetReportFieldEnum as Fields } from 'Common/FieldEnum';
import { Filter, Main } from 'Containers/';
import OhioDailyWorksheetForm from './components/OhioDailyWorksheetForm';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { OHIO_DAILY_WORKSHEET_REPORT_FORM_NAME } from 'Common/FormEnum';
import { MONTH_YEAR_DATE_FORMAT } from 'Common/Constants';
import MPWWebApi from 'API/MPWApi';
import { toastError, toastInfo } from 'Common/ToastHelper';
import { mapIdKeyToMealType, mealTypeEnum } from './helpers/constants';

class OhioDailyWorksheetReportContainer extends Component {
  state = {
    loading: false,
    nonNeedyItemOptions: [],
  };

  getMainProps = () => {
    return {
      toolbox: {
        formName: OHIO_DAILY_WORKSHEET_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: this.state.loading,
          disabled: this.state.loading,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.getNonNeedyItems();
  }

  getNonNeedyItems = async () => {
    this.setState({ loading: true });

    const noneOption = {
      value: '',
      text: 'None',
    };

    try {
      const response = await MPWWebApi.getGeneric('serveditem/nonneedyitems');
      const options = response.data.Data;

      const sortedOptions = options.reduce(
        (carry, option) => {
          const key = mapIdKeyToMealType[option.ItemIdLetter];
          return {
            ...carry,
            [key]: [
              ...carry[key],
              {
                value: option.Id,
                text: `${option.Id} ${option.ShortDescription}`,
              },
            ],
          };
        },
        {
          [mealTypeEnum.Breakfast]: [noneOption],
          [mealTypeEnum.Lunch]: [noneOption],
        }
      );

      this.setState({ nonNeedyItemOptions: sortedOptions });
    } catch (error) {
      return this.handleResponseError(error);
    }
    this.setState({ loading: false });
  };

  handleSubmit = async values => {
    this.setState({ loading: true });
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'reports/ohiodailyworksheetreport',
        values
      );

      const report = response.data.Data;

      if (!report) {
        toastInfo('No data found!');
      }

      ReportGeneration(report, 'Ohio Daily Worksheet');
    } catch (error) {
      return this.handleResponseError(error);
    }

    this.setState({ loading: false });
  };

  handleResponseError = error => {
    has(error, 'response.data.Errors')
      ? error.response.data.Errors.forEach(e => {
          toastError(e.Title);
        })
      : toastError(error.response.statusText);
    return this.setState({ loading: false });
  };

  render() {
    const { loading, nonNeedyItemOptions } = this.state;
    const { selectedMealType } = this.props;
    return (
      <Fragment>
        {loading && <LoadingPage />}
        <Filter title={'Ohio Daily Worksheet Report'} />
        <Main {...this.getMainProps()}>
          <OhioDailyWorksheetForm
            onSubmit={this.handleSubmit}
            onChange={(changes, dispatch, props, previousValues) => {
              if (
                changes[Fields.MealType] !== previousValues[Fields.MealType]
              ) {
                dispatch(
                  resetSection(
                    OHIO_DAILY_WORKSHEET_REPORT_FORM_NAME,
                    Fields.NonNeedyItemId
                  )
                );
              }
            }}
            initialValues={{
              [Fields.MealType]: '',
              [Fields.Date]: moment().format(MONTH_YEAR_DATE_FORMAT),
              [Fields.NonNeedyItemId]: '',
              [Fields.County]: '',
              [Fields.SiteIds]: [],
            }}
            nonNeedyItemOptions={get(nonNeedyItemOptions, selectedMealType, [])}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const selector = formValueSelector(OHIO_DAILY_WORKSHEET_REPORT_FORM_NAME);
  return {
    selectedMealType: selector(state, Fields.MealType),
  };
};

export const OhioDailyWorksheetReport = connect(
  mapStateToProps,
  {}
)(OhioDailyWorksheetReportContainer);



// WEBPACK FOOTER //
// ./src/pages/ohiodailyworksheetreport/OhioDailyWorksheetReport.js